import { render } from "./EmailList.vue?vue&type=template&id=6b8cc1c1&scoped=true"
import script from "./EmailList.vue?vue&type=script&lang=js"
export * from "./EmailList.vue?vue&type=script&lang=js"

import "./EmailList.vue?vue&type=style&index=0&id=6b8cc1c1&lang=less"
import "./EmailList.vue?vue&type=style&index=1&id=6b8cc1c1&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8cc1c1"]])

export default __exports__